import React from "react";
import { MapPin, Mail } from "lucide-react";

const AppBar: React.FC = () => {
  return (
    <div className="w-full bg-gray-100 p-4 flex justify-between items-center shadow-md">
      <div className="flex items-center gap-2">
        <MapPin className="text-red-500" size={20} />
        <span className="text-gray-700">
          Cumhuriyet mahallesi Atatürk caddesi Şenel İş Merkezi No: 7/8 Polatlı / Ankara
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Mail className="text-red-500" size={20} />
        <span className="text-gray-700">ib.kocabay18@gmail.com</span>
      </div>
    </div>
  );
};

export default AppBar;
